module.exports = __webpack_public_path__ + "static/media/heartCondition.897593b5.mp3";